import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

// ES
import esAuth from './locales/es/auth.json'
import esCommon from './locales/es/common.json'
import esErrors from './locales/es/errors.json'
import esRegister from './locales/es/register.json'
import esValidation from './locales/es/validation.json'
import esDashboard from './locales/es/dashboard.json'
import esSimulador from './locales/es/simulador.json'
import esProductos from './locales/es/productos.json'
import esContacto from './locales/es/contacto.json'
import esPerfilamiento from './locales/es/perfilamiento.json'
import esProfile from './locales/es/profile.json'

// EN
import enAuth from './locales/en/auth.json'
import enCommon from './locales/en/common.json'
import enErrors from './locales/en/errors.json'
import enRegister from './locales/en/register.json'
import enValidation from './locales/en/validation.json'
import enDashboard from './locales/en/dashboard.json'
import enSimulador from './locales/en/simulador.json'
import enProductos from './locales/en/productos.json'
import enContacto from './locales/en/contacto.json'
import enPerfilamiento from './locales/en/perfilamiento.json'
import enProfile from './locales/en/profile.json'

export const SUPPORTED_LANGUAGES = ['es', 'en'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common: esCommon,
        auth: esAuth,
        validation: esValidation,
        errors: esErrors,
        register: esRegister,
        dashboard: esDashboard,
        simulador: esSimulador,
        productos: esProductos,
        contacto: esContacto,
        perfilamiento: esPerfilamiento,
        profile: esProfile,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        validation: enValidation,
        errors: enErrors,
        register: enRegister,
        dashboard: enDashboard,
        simulador: enSimulador,
        productos: enProductos,
        contacto: enContacto,
        perfilamiento: enPerfilamiento,
        profile: enProfile,
      },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: 'common',
    ns: ['common', 'auth', 'validation', 'errors', 'register', 'dashboard', 'simulador', 'productos', 'contacto', 'perfilamiento', 'profile'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18n
